import { DESC_CONSTANTS } from "./constants";
import MagnifiedImageFrame from "@/components/magnifyImageFrame";

const CollabComp = () => {
  return <MagnifiedImageFrame {...DESC_CONSTANTS} />;
};

export default CollabComp;
